import {Type} from "class-transformer";

import {AbstractItem} from "@app/shared/classes/item";
import {Address} from "@app/shared/classes/address";
import {PartnerExternalContact} from "@app/shared/classes/partner-external-contact";
import {Vendor} from "@app/shared/classes/vendor";
import {serializeType} from "@app/shared/classes/common";
import {ChargeCode} from "@app/shared/classes/charge-code";
import {ItemType} from "@app/shared/enums/item-type.enum";
import {FundingType} from "@app/shared";

export class PurchaseReturnChargeCode extends ChargeCode {
  chargeCodeId: number;
  chargeCodeOwnerName: string;

  allocationPercent: number;
  allocationAmount: number;
  taxAmount: number;

  returnItemId: number;
}


export class ReturnItem {
  id: number;
  version: number;
  purchaseReturnId: number;
  receiptItemId: number;

  subtype: ItemType;
  fundingType: FundingType;
  nameOrNumber: string;
  description: string;
  unitOfMeasureId: number;
  unitOfMeasureDescription: string;

  isTaxable: boolean;
  qtyReturned: number;
  creditAmount: number;
  returnReason: string;

  qtyOrdered: number;
  qtyReceived: number;
  unitCost: number;
  taxAmount: number;

  @Type(serializeType(AbstractItem)) abstractItemDetail?: AbstractItem;
  @Type(serializeType(PurchaseReturnChargeCode)) returnChargeCodes: PurchaseReturnChargeCode[];

  returnedAll: boolean;
  itemSelected?: boolean;               // used for display - has to be deleted when saving or updating
}

export class PurchaseReturn {
  id?: number;
  version?: number;

  purchaseReturnNumber?: string;
  returnedOn: string;
  referenceNumber?: string;
  creditAppliedAmount: number;

  subTotalAmount: number;
  taxAmount: number;
  taxRate: number;
  shippingCost: number;
  totalCreditAmount: number;
  salesTaxPercentage: number;

  discountAmount: number;                       // does not exist in the backend
  discountPercentage: number;
  purchaseOrderId: number;
  purchaseOrderNumberDetail: string;
  invoiceId: number;
  invoiceNumber: string;
  invoiceStatus: string;
  invoiceNotApproved: boolean;
  receiptId: number;
  receiptNumber: string;
  @Type(serializeType(Address)) receivedAddressDetail: Address;
  returnToId: number;
  @Type(serializeType(Address)) returnToAddressDetail: Address;
  returnedById: number;
  returnedByFullName: string;
  contactId: number;
  @Type(serializeType(PartnerExternalContact)) vendorContactDetail: PartnerExternalContact;
  vendorId: number;
  @Type(serializeType(Vendor)) vendorDetail: Vendor;
  @Type(serializeType(Address)) vendorAddressDetail: Address;

  @Type(serializeType(ReturnItem)) returnItems: ReturnItem[];


  constructor(vendorId?: number) {
    if (vendorId) {
      this.vendorId = vendorId;
    }
    this.returnItems = new Array<ReturnItem>();
  }
}
